module.exports = __webpack_public_path__ + "static/media/Illustration.ff6a9331.png";